// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2VgWE","requiredAsterisk":"Info_requiredAsterisk__2eJsf"};